export default class Virtual {
    redirectUrl: string;
    fullGameUrl: string;
    demoGameUrl: string;
    additionalParams: string;
    checkOriginUrl: string;
    imageSrc: string;
    name: string;
    test: boolean;
    description: string;
    isNew: boolean;
    fullMobileGameUrl: string | null;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/games/Virtual.ts